var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHealthDataPlatform2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_15096",
    "data-name": "Group 15096",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.508,
    height: 47.234,
    viewBox: "0 0 33.508 47.234",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15095",
    "data-name": "Group 15095",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41112",
    "data-name": "Path 41112",
    d: "M278.809,76.916l.728-3.856h-3.518l2.475-6.038h3.228l-1.968,3.557h4.085Z",
    transform: "translate(-260.582 -67.021)",
    fill: "#29bcc1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41113",
    "data-name": "Path 41113",
    d: "M284.126,77.9l1.539-1.929-1.955-1.035,3.152-2.628,1.794.95-2.141,1.4,2.27,1.2Z",
    transform: "translate(-257.887 -65.17)",
    fill: "#29bcc1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41114",
    "data-name": "Path 41114",
    d: "M271.424,77.4,270.1,75.318l-1.616,1.511-1.457-3.837,1.483-1.387.623,2.479,1.877-1.755Z",
    transform: "translate(-263.731 -65.415)",
    fill: "#29bcc1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41115",
    "data-name": "Path 41115",
    d: "M264.587,105.812H298.1c.011-.134-.816-6.575-1-7.195a3.772,3.772,0,0,0-1.157-2.3c-.374-.275-5.438-3.176-7.58-4.412-.451-.261-.922-.487-1.487-.783-.146.15-.285.294-.428.435a6.891,6.891,0,0,1-6.063,2.193,5.909,5.909,0,0,1-1.823-.521,22.779,22.779,0,0,1-3-2.017c-.373.154-8.041,4.616-9.218,5.276a.728.728,0,0,0-.316.462C265.918,97.619,264.582,105.3,264.587,105.812Z",
    transform: "translate(-264.587 -58.577)",
    fill: "#29bcc1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41116",
    "data-name": "Path 41116",
    d: "M287.7,84.337a2.34,2.34,0,0,0,.288.336c.65.725.4,1.893.135,2.725-.323,1.024-.968,1.892-1.219,2.938a.936.936,0,0,1-.223.5,2.158,2.158,0,0,1-.385.209,1.518,1.518,0,0,0-.509.674c-1.261,2.5-3.492,5.389-6.586,5.339-2.845-.045-4.883-2.667-6.181-4.922a7.756,7.756,0,0,0-.485-.89c-.171-.223-.478-.293-.65-.52a1.118,1.118,0,0,1-.154-.339,23.92,23.92,0,0,0-.949-2.4,5.608,5.608,0,0,1-.5-2.409.907.907,0,0,1,.307-.848.741.741,0,0,0,.171-.517,21.83,21.83,0,0,1,.126-2.82,8.288,8.288,0,0,1,.96-2.968,6.547,6.547,0,0,1,1.931-2.051,8.443,8.443,0,0,1,3.1-1.179,6.293,6.293,0,0,1,3.661.344,19.24,19.24,0,0,0,3.361.633,5.3,5.3,0,0,1,3.557,4.048,11.143,11.143,0,0,1,.163,3.41,1.252,1.252,0,0,0,.07.678Z",
    transform: "translate(-262.591 -64.2)",
    fill: "#29bcc1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthDataPlatform2);
export default __webpack_public_path__ + "static/media/health_data_platform2.c0b8e4542ca8290610cef6af27f782d1.svg";
export { ForwardRef as ReactComponent };